import React, { useState } from "react";
import BusinessProfile from "./steps/BusinessProfile";
import BusinessCategories from "./steps/BusinessCategories";
import BusinessDescribe from "./steps/BusinessDescribe";
import { useHistory } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { BUILD_PROFILE } from "../../mutation/BuildProfile";
import { hasuraClient } from "../../apolloClient";
import {
  GET_COUNCIL_CATEGORIES,
  GET_USER_WITH_COUNCIL_PROFILE,
} from "../../query/buildProfileQueries";
import { UPADTE_USER } from "../../mutation/updateUser";

const BuildProfileMain = () => {
  const [data, setData] = useState({
    description: "",
    name: "",
    state: "",
    population: "",
    categories: "",
  });

  const [currentStep, setCurrentStep] = useState(0);

  const [apiError, setApiError] = useState();

  const [categories, setCategories] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");

  const isCouncilNameDisabled = false;

  const history = useHistory();

  const [updateUser] = useMutation(UPADTE_USER, {
    client: hasuraClient,
  });

  const [BuildProfile] = useMutation(BUILD_PROFILE, {
    client: hasuraClient,
  });
  useQuery(GET_COUNCIL_CATEGORIES, {
    client: hasuraClient,
    onCompleted: (res) => {
      const modifiedRes = res.council_categories.map((category) => ({
        ...category,
        selected: false,
      }));
      setCategories(modifiedRes);
    },
  });
  useQuery(GET_USER_WITH_COUNCIL_PROFILE, {
    client: hasuraClient,
    onCompleted: (res) => {
      setData((prev) => ({
        ...prev,
        name: res?.users[0]?.council_profile?.name
          ? res?.users[0]?.council_profile?.name
          : "",
        state: res?.users[0]?.council_profile?.state,
      }));
    },
  });

  const makeRequest = (formData) => {
    BuildProfile({
      variables: {
        data: {
          description: formData.description,
          name: formData.name,
          population: `${formData.population}`,
          state: formData.state,
          categories: formData.categories,
        },
      },
    })
      .then((response) => {
        localStorage.setItem(
          "profile_id",
          response.data.insert_council_profile_one.id
        );
        updateUser({
          variables: {
            userId: localStorage.getItem("user_id"),
            is_profile_setup: true,
          },
        })
          .then(() => {
            localStorage.setItem("is_profile_setup", true);
            history.push("/build-profile-success");
          })
          .catch(() => {});
      })
      .catch((e) => {
        const errors = e.graphQLErrors;

        if (errors[0] && errors[0].message) {
          setApiError(errors[0].message);
        }
      });
  };

  const handleNextStep = (newData, final = false) => {
    setData((prev) => ({ ...prev, ...newData }));

    if (final) {
      makeRequest(newData);
      return;
    }

    setCurrentStep((prev) => prev + 1);
  };

  const handleBackStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const steps = [
    <BusinessProfile
      next={handleNextStep}
      data={data}
      isCouncilNameDisabled={isCouncilNameDisabled}
    />,
    <BusinessCategories
      back={handleBackStep}
      next={handleNextStep}
      data={data}
      categories={categories}
      setCategories={setCategories}
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
    />,
    <BusinessDescribe
      back={handleBackStep}
      next={handleNextStep}
      data={data}
    />,
  ];

  return (
    <div className="businessprofile-main">
      <div className="dots">
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep === 0 ? "#696AE7" : "#E1E1E1",
            marginRight: "25px",
          }}
        ></div>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep === 1 ? "#696AE7" : "#E1E1E1",
            marginRight: "25px",
          }}
        ></div>
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: currentStep === 2 ? "#696AE7" : "#E1E1E1",
            marginRight: "25px",
          }}
        ></div>
      </div>

      {steps[currentStep]}

      {apiError ? <div className="error-message">{apiError}</div> : null}

      {/* <BusinessProfile />
            <BusinessCategories />
            <BusinessDescribe /> */}
    </div>
  );
};

export default BuildProfileMain;
